/************
 * Author : Sakthipriya
 * Developed by : Shiva Software Solutions
 * Date : 11-05-2023
 * Descriptions : Call api response using reducers
 * Modified Date :
 * Modified Author Name :
 * Modified Fuction :
 ************/
import {
  CLIENT_LIST_REPORT,
  DOCTOR_REPORT,
  SEARCH_DISEASE_DATA,
  REPORT_RESULT,
  ERX_REPORT_RESULT,
  CLIENT_REPORT_RESULT,
  REGI_REPORT_RESULT,
  REPORT_OLD_RESULT,
  REPORT_RESULT_SUCCESS,
  REPORT_OLD_RESULT_SUCCESS,
  DIGI_REPORT_RESULT,
  DIGI_PREVIEW_DATA,
  DIGI_REPORT_RESULT_SUCCESS,
  REPORT_COUNT,
  ERX_REPORT_COUNT,
  DIGITIZED_REPORT_COUNT,
  REPORT_OLD_COUNT,
  DIGI_REPORT_COUNT,
  EXCEL_REPORT_LIST,
  EXCEL_OLD_REPORT_LIST,
  EXCEL_AMAZON_REPORT_LIST,
  DIGI_AMAZON_REPORT_LIST,
  PROCEDURE_REPORT,
  ALLERGY_REPORT,
  TAG_CATEGORY_REPORT,
  SEARCH_DIAGONSIS_DATA,
  ERX_DATA_RHTML_NO_DATA,
  SEARCH_SPECIALIZATION_DATA,
  SEARCH_SYMPTOMS_DATA,
  SEARCH_MEDICINE_DATA,
  ERX_DATA_RHTML,
  OPDDIGITIZATION_COUNT,
  OPDDIGITIZATION_MEDICINE,
  DIGITIZATION_DISEASE,
  INVESTIGATION_LAB,
  INVESTIGATION_RADIO,
  MEDICINE_CATEGORY_COUNT,
  DOCTOR_SPECIALIZATION_COUNT,
  INVESTIGATION_MRI_XRay,
  INVESTIGATION_BLOOD_TEST,
  INVESTIGATION_CATEGORY,
  INVESTIGATION_CATEGORY_DATA,
  PRESCRIPTION_COUNT,
  GET_ERX_FORMS_PDF,
  PRESCRIPTION_LOADER,
  ANTIBIOTIC_LOADER,
  DISEASE_LOADER,
  LAB_LOADER,
  RADIOLOGY_LOADER,
  MRI_XRAY_LOADER,
  SPECIALIZATION_LOADER,
  INVESCATEGORY_LOADER,
  BLOODTEST_LOADER,
  TC_REPORT_COUNT,
  RADIOLOGY_CATEGORY_REPORT,
  INV_OTHER_OPTIONS,
  CHART_ERX_RESULT,
  CHART_ERX_TOTAL_RECORD,
  CHART_ERX_DETAILS_LOADER,
  CHART_SURGERY_DATA,
  SURGERY_LOADER,
} from '../../shared/constants/ActionTypes';
const initialState = {
  clientlist: '',
  doctorlist: '',
  digitizedreportcount: '',
  reportoldcount: '',
  digireportcount: '',
  allergyreport: '',
  procedurereport: '',
  search_disease_data: [],
  excel_report: [],
  excel_old_report: [],
  excel_amazon_report: [],
  excel_digi_report: [],
  tagcategory: [],
  reportresult: [],
  eRxreportresult: [],
  clientreportresult: [],
  rigireportresult: [],
  reportOldresult: [],
  digireportresult: [],
  digiPreviewdata: [],
  search_diagonsis_data: [],
  search_symptoms_data: [],
  search_medicine_data: [],
  search_specialization_data: [],
  reportresultsuccess: '',
  reportoldresultsuccess: '',
  digireportresultsuccess: '',
  erxrhtmldata: '',
  erxrhtmlnodata: '',
  opddigitization_report_count: {},
  opddigitization_report_medicine: [],
  digitization_report_diseases: [],
  inves_labtype: [],
  inves_radiotype: [],
  medicine_category_count: [],
  inves_MRI_XRay: [],
  doctor_specialization: [],
  inves_blood_test: [],
  inves_category: [],
  category_master: [],
  prescription_count: {},
  prescription_loader: false,
  antibiotic_loader: false,
  disease_loader: false,
  lab_loader: false,
  radiology_loader: false,
  specialization_loader: false,
  mri_xray_loader: false,
  invescategory_loader: false,
  bloodtest_loader: false,
  reportcount: '',
   getErxFormsPDF: [],
   tc_report_count: '',
  radiologycategory: [],
  invOtherOptions: [],
  charteRxResult:{},
  chartErxTotalRecord:0,
  charteRxdetailsLoader: false,
  chartSurgeryData:[],
  surgery_loader: false,
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case TC_REPORT_COUNT:
      return {
        ...state,
        tc_report_count: action.payload,
      };
    case CLIENT_LIST_REPORT:
      return {
        ...state,
        clientlist: action.payload,
      };
    case REPORT_RESULT:
      return {
        ...state,
        reportresult: action.payload,
      };
    case ERX_REPORT_RESULT:
      return {
        ...state,
        eRxreportresult: action.payload,
      };
    case CLIENT_REPORT_RESULT:
      return {
        ...state,
        clientreportresult: action.payload,
      };
    case REGI_REPORT_RESULT:
      return {
        ...state,
        rigireportresult: action.payload,
      };
    case REPORT_OLD_RESULT:
      return {
        ...state,
        reportOldresult: action.payload,
      };
    case REPORT_RESULT_SUCCESS:
      return {
        ...state,
        reportresultsuccess: action.payload,
      };
    case REPORT_OLD_RESULT_SUCCESS:
      return {
        ...state,
        reportoldresultsuccess: action.payload,
      };
    case DIGI_REPORT_RESULT:
      return {
        ...state,
        digireportresult: action.payload,
      };
    case DIGI_PREVIEW_DATA:
      return {
        ...state,
        digiPreviewdata: action.payload,
      };
    case DIGI_REPORT_RESULT_SUCCESS:
      return {
        ...state,
        digireportresultsuccess: action.payload,
      };

    case DIGITIZED_REPORT_COUNT:
      return {
        ...state,
        digitizedreportcount: action.payload,
      };
    case REPORT_OLD_COUNT:
      return {
        ...state,
        reportoldcount: action.payload,
      };
    case DIGI_REPORT_COUNT:
      return {
        ...state,
        digireportcount: action.payload,
      };
    case EXCEL_REPORT_LIST:
      return {
        ...state,
        excel_report: action.payload,
      };
    case EXCEL_OLD_REPORT_LIST:
      return {
        ...state,
        excel_old_report: action.payload,
      };
    case EXCEL_AMAZON_REPORT_LIST:
      return {
        ...state,
        excel_amazon_report: action.payload,
      };
    case ERX_REPORT_COUNT:
      return {
        ...state,
        reportcount: action.payload,
      };
    case DIGI_AMAZON_REPORT_LIST:
      return {
        ...state,
        excel_digi_report: action.payload,
      };
    case ALLERGY_REPORT:
      return {
        ...state,
        allergyreport: action.payload,
      };
    case PROCEDURE_REPORT:
      return {
        ...state,
        procedurereport: action.payload,
      };
    case SEARCH_MEDICINE_DATA:
      return {
        ...state,
        search_medicine_data: action.payload,
      };
    case TAG_CATEGORY_REPORT:
      return {
        ...state,
        tagcategory: action.payload,
      };
    case DOCTOR_REPORT:
      return {
        ...state,
        doctorlist: action.payload,
      };
    case SEARCH_DISEASE_DATA:
      return {
        ...state,
        search_disease_data: action.payload,
      };
    case SEARCH_DIAGONSIS_DATA:
      return {
        ...state,
        search_diagonsis_data: action.payload,
      };
    case ERX_DATA_RHTML:
      return {
        ...state,
        erxrhtmldata: action.payload,
      };
    case ERX_DATA_RHTML_NO_DATA:
      return {
        ...state,
        erxrhtmlnodata: action.payload,
      };
    case SEARCH_SYMPTOMS_DATA:
      return {
        ...state,
        search_symptoms_data: action.payload,
      };
    case SEARCH_SPECIALIZATION_DATA:
      return {
        ...state,
        search_specialization_data: action.payload,
      };
    case OPDDIGITIZATION_COUNT:
      return {
        ...state,
        opddigitization_report_count: action.payload,
      };
    case OPDDIGITIZATION_MEDICINE:
      return {
        ...state,
        opddigitization_report_medicine: action.payload,
      };
    case DOCTOR_SPECIALIZATION_COUNT:
      return {
        ...state,
        doctor_specialization: action.payload,
      };
    case DIGITIZATION_DISEASE:
      return {
        ...state,
        digitization_report_diseases: action.payload,
      };
    case INVESTIGATION_LAB:
      return {
        ...state,
        inves_labtype: action.payload,
      };
    case INVESTIGATION_RADIO:
      return {
        ...state,
        inves_radiotype: action.payload,
      };
    case MEDICINE_CATEGORY_COUNT:
      return {
        ...state,
        medicine_category_count: action.payload,
      };

    case INVESTIGATION_MRI_XRay:
      return {
        ...state,
        inves_MRI_XRay: action.payload,
      };
    case INVESTIGATION_BLOOD_TEST:
      return {
        ...state,
        inves_blood_test: action.payload,
      };
    case INVESTIGATION_CATEGORY:
      return {
        ...state,
        inves_category: action.payload,
      };
    case INVESTIGATION_CATEGORY_DATA:
      return {
        ...state,
        category_master: action.payload,
      };
    case PRESCRIPTION_COUNT:
      return {
        ...state,
        prescription_count: action.payload,
      };
    case GET_ERX_FORMS_PDF:
      return {
        ...state,
        getErxFormsPDF: action.payload,
      };
    case PRESCRIPTION_LOADER:
      return {
        ...state,
        prescription_loader: action.payload,
      };

    case ANTIBIOTIC_LOADER:
      return {
        ...state,
        antibiotic_loader: action.payload,
      };
    case DISEASE_LOADER:
      return {
        ...state,
        disease_loader: action.payload,
      };
    case LAB_LOADER:
      return {
        ...state,
        lab_loader: action.payload,
      };
    case RADIOLOGY_LOADER:
      return {
        ...state,
        radiology_loader: action.payload,
      };
    case SPECIALIZATION_LOADER:
      return {
        ...state,
        specialization_loader: action.payload,
      };
    case MRI_XRAY_LOADER:
      return {
        ...state,
        mri_xray_loader: action.payload,
      };
    case INVESCATEGORY_LOADER:
      return {
        ...state,
        invescategory_loader: action.payload,
      };
    case BLOODTEST_LOADER:
      return {
        ...state,
        bloodtest_loader: action.payload,
      };
     case RADIOLOGY_CATEGORY_REPORT:
      return {
        ...state,
        radiologycategory: action.payload,
      };
     case INV_OTHER_OPTIONS:
      return {
        ...state,
        invOtherOptions: action.payload,
      };
    case CHART_ERX_RESULT:
      return {
        ...state,
        charteRxResult: action.payload,
      };
    case CHART_ERX_TOTAL_RECORD:
      return {
        ...state,
        chartErxTotalRecord: action.payload,
      };
    case CHART_ERX_DETAILS_LOADER:
      return {
        ...state,
        charteRxdetailsLoader: action.payload,
      };
    case CHART_SURGERY_DATA:
      return {
        ...state,
        chartSurgeryData: action.payload,
      };
    case SURGERY_LOADER:
      return {
        ...state,
        surgery_loader: action.payload,
      };
    default:
      return state;
  }
};
export default reportReducer;
